import React from "react";
import cns from "classnames";
import { transparentize } from "polished";
import Fade from "@material-ui/core/Fade";
import { ThemeType } from "@theme";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  [key: string]: any;
  in?: boolean;
  error?: boolean;
  normal?: boolean;
  transparent?: boolean;
};

export function Overlay(props: Props) {
  const { children, error, in: inProp, normal } = props;
  const classes = useStyles({});

  const className = cns(classes.root, {
    [classes.default]: !error && !props.transparent,
    [classes.error]: error,
    [classes.normal]: normal
  });

  return (
    <Fade in={inProp} mountOnEnter unmountOnExit>
      <div className={className} {...props} data-test="Overlay">
        {children}
      </div>
    </Fade>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  default: {
    backgroundColor: transparentize(0.8, "gray")
  },

  normal: {
    backgroundColor: "white",
    color: "gray",
    opacity: "0.3 !important"
  },

  error: {
    backgroundColor: theme.palette.error.background,
    color: "white"
  }
}));
